export const MaximumWordLength = (word, length) => {
    if (word.length <= length) {
        return word;
    } else {
        return word.slice(0, length) + "...";
    }
}